
import { Box, Breadcrumbs, Icon, Link, Tooltip, Typography } from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";
import { Ico_Tasks } from "@sagecentral/core-ui";
import { useFeatureEnabled } from "hooks/shared";
import { useTaskPermissions } from "hooks/tasks";
import { ITaskOverview } from "models/tasks";
import React from "react";

const FontStyleDef = {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'black'
};

const ParentFontStyleDef = {
    ...FontStyleDef,
    display: "block",
    width: '90%'
};

const LinkStyle = styled(Link)({
    ...FontStyleDef,
    color: '#0066CC'
});

type TaskBreadcrumbsProps = {
    task: ITaskOverview;
};

const TaskBreadcrumbs = (props: TaskBreadcrumbsProps) => {
    const { task } = props;

    const theme = useTheme();
    const [ wave4Enabled ] = useFeatureEnabled('wave-4');
    const permissions = useTaskPermissions();

    const canViewWorkflow = permissions?.canViewWorkflows;
    const canEditWorkflow = permissions?.canEditWorkflows;

    const workitemEditUrl = wave4Enabled 
        ? process.env.REACT_APP_PUBLIC_URL + `/workitems/${task.workItem.id}/overview`
        : process.env.REACT_APP_CLASSIC_URL + `/workitemenduser/editworkitem?workitemId=${task.workItem.id}`;
    const workflowEditUrl = process.env.REACT_APP_CLASSIC_URL + `/workflowinstance/editworkflow?workflowInstanceID=${task.workflow.id}`;
    const getProjectUrl = (projectId: string) => wave4Enabled 
        ? process.env.REACT_APP_PUBLIC_URL + `/workitems/${projectId}/overview`
        : process.env.REACT_APP_CLASSIC_URL + `/workitemenduser/editworkitem?workitemId=${projectId}`;
    const workflowViewUrl = process.env.REACT_APP_CLASSIC_URL + `/workflowinstance/viewworkflow?workflowInstanceID=${task.workflow.id}`;
    return (
        <Box
            sx={{
                marginLeft: '48px',
                display: 'row',
                alignContent: 'center',
                marginTop: '24px'
            }}>
            {task.parents && task.parents.length > 0 && task.parents.some(x => x.id > 0) ?
                <Typography sx={ParentFontStyleDef}>
                    From Project:&nbsp;
                    {task.parents.map((parent, index) => (
                        <React.Fragment key={index}>
                            {parent.id > 0 && <>
                            <LinkStyle href={getProjectUrl(parent.id.toString())}>
                                {parent.name}
                            </LinkStyle>
                            {index !== task.parents!.length - 1 && ', '}
                            </>}
                        </React.Fragment>
                    ))}
                </Typography>

                : null}
            <Breadcrumbs
                separator='>'
                sx={{
                    display: "inline-block"
                }}
            >

                <Typography sx={FontStyleDef}>
                    
                    <Tooltip title="Work Item" arrow><Box sx={{display: "inline"}}>{"Work Item: "}</Box></Tooltip>
                    
                    
                    <LinkStyle href={workitemEditUrl}>
                        {task.workItem.name}
                        &nbsp;({task.workItem.id})
                    </LinkStyle>                    
                </Typography>

                <Typography sx={FontStyleDef}>
                    Workflow:&nbsp;
                    { canEditWorkflow ?
                        <LinkStyle href={workflowEditUrl}>
                            {task.workflow.name}
                        </LinkStyle>
                        :
                        <span style={FontStyleDef}>
                            {task.workflow.name}
                        </span>
                    }
                </Typography>
            </Breadcrumbs>
        </Box>
    );
};

export default TaskBreadcrumbs;